import Vue from 'vue';

/**
 * Notify info
 * @param {String} message
 */
export default function notifyInfo(message) {
  Vue.toasted.info(message);
}
